import { mapGetters } from 'vuex';

export default {
  name: 'EcsInteractionMixin',

  computed: {
    ...mapGetters('AGENT', ['loggedInAgent']),

    isDestinationOnInternalInteraction() {
      return this.interaction.isInternal && this.interaction.destinationContact.id === this.loggedInAgent.id;
    }
  }
};
